import {remCalc} from '../_utils'
import {Typography} from '../types/typography.types'
import fonts from './fonts'

const primaryDefault = {
    fontFamily: `${fonts.fonts.primary}`,
    fontStyle: 'normal',
    letterSpacing: 0,
}

const secondaryDefault = {
    fontFamily: `${fonts.fonts.secondary}`,
    fontStyle: 'normal',
    letterSpacing: 0,
}

const typography: Typography = {
    textStyles: {
        'display-xlarge': {
            ...primaryDefault,
            fontSize: {base: remCalc(40), md: remCalc(184)},
            lineHeight: {base: remCalc(44), md: remCalc(192)},
        },
        'display-large': {
            ...primaryDefault,
            fontSize: {base: remCalc(32), md: remCalc(68)},
            lineHeight: {base: remCalc(40), md: remCalc(76)},
        },
        'display-small': {
            ...primaryDefault,
            fontSize: {base: remCalc(30), md: remCalc(34), lg: remCalc(42)},
            lineHeight: {base: remCalc(34), md: remCalc(42)},
        },
        'head-xlarge': {
            ...secondaryDefault,
            fontSize: {base: remCalc(30), md: remCalc(34), lg: remCalc(38)},
            lineHeight: {base: remCalc(34), md: remCalc(38)},
        },
        'head-large': {
            ...secondaryDefault,
            fontSize: {base: remCalc(28), md: remCalc(32)},
            lineHeight: {base: remCalc(30), md: remCalc(32)},
        },
        'head-medium': {
            ...secondaryDefault,
            fontSize: {base: remCalc(24), md: remCalc(28)},
            lineHeight: {base: remCalc(26), md: remCalc(30)},
        },
        'head-small': {
            ...secondaryDefault,
            fontSize: {base: remCalc(20), md: remCalc(22), lg: remCalc(24)},
            lineHeight: {base: remCalc(24), md: remCalc(26)},
        },
        'head-xsmall': {
            ...secondaryDefault,
            fontSize: {base: remCalc(18), md: remCalc(20)},
            lineHeight: {base: remCalc(22)},
        },
        'head-xxsmall': {
            ...secondaryDefault,
            fontSize: {base: remCalc(14)},
            lineHeight: {base: remCalc(20)},
        },
        'body-xxlarge': {
            ...secondaryDefault,
            fontSize: {base: remCalc(22)},
            lineHeight: {base: remCalc(28)},
        },
        'body-xlarge': {
            ...secondaryDefault,
            fontSize: {base: remCalc(20)},
            lineHeight: {base: remCalc(26)},
        },
        'body-large': {
            ...secondaryDefault,
            fontSize: {base: remCalc(18)},
            lineHeight: {base: remCalc(22)},
        },
        'body-medium': {
            ...secondaryDefault,
            fontSize: {base: remCalc(16)},
            lineHeight: {base: remCalc(20)},
        },
        'body-small': {
            ...secondaryDefault,
            fontSize: {base: remCalc(14)},
            lineHeight: {base: remCalc(16)},
        },
        'body-xsmall': {
            ...secondaryDefault,
            fontSize: {base: remCalc(12)},
            lineHeight: {base: remCalc(14)},
        },
        'body-xxsmall': {
            ...secondaryDefault,
            fontSize: {base: remCalc(10)},
            lineHeight: {base: remCalc(12)},
        },
    },
}

export default typography
